module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/past_bg.93416fd5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/past_bg.png
// module id = 2866
// module chunks = 11